
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * GatewayStatus enum
 */
class GatewayStatus {
  /**
   * Initialize enum with a given value
   * @param {GatewayStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof GatewayStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!GatewayStatus}
   * @param {!GatewayStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof GatewayStatus)) {
      throw new TypeError('Instance of GatewayStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!GatewayStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!GatewayStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === GatewayStatus.OFFLINE.value) {
      return 'OFFLINE'
    }
    if (this.value === GatewayStatus.LOCAL_ONLINE.value) {
      return 'LOCAL_ONLINE'
    }
    if (this.value === GatewayStatus.REMOTE_ONLINE.value) {
      return 'REMOTE_ONLINE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!GatewayStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!GatewayStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!GatewayStatus} Created enum
   */
  static fromObject (other) {
    return new GatewayStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
GatewayStatus.OFFLINE = new GatewayStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
GatewayStatus.LOCAL_ONLINE = new GatewayStatus(0 + 1)
// noinspection PointlessArithmeticExpressionJS
GatewayStatus.REMOTE_ONLINE = new GatewayStatus(0 + 2)

export { GatewayStatus };

/**
 * Fast Binary Encoding GatewayStatus field model
 */
class FieldModelGatewayStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelGatewayStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelGatewayStatus}
   * @param {GatewayStatus=} defaults Default value, defaults is new GatewayStatus()
   * @returns {!GatewayStatus} Result value
   */
  get (defaults = new GatewayStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new GatewayStatus(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelGatewayStatus}
   * @param {!GatewayStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelGatewayStatus };
